import { render } from "./DiagnosticoController.vue?vue&type=template&id=14c8bb71"
import script from "./DiagnosticoController.vue?vue&type=script&lang=js"
export * from "./DiagnosticoController.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__